import { AnyDocument } from '../../../types';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { DocumentParams } from '../types/DocumentParams';

export const getDocumentTransitionsQueryKey = <
  DocumentType extends AnyDocument,
>(
  documentId: DocumentType['id'],
  documentParams: DocumentParams,
) => [DOCUMENTS_BASE_PATH, 'transitions', documentId, documentParams];
